/* * ==============================================================================
 * SAKA ARCHITECT: SURGICAL FILTER MAPPING & BUG FIXES
 * Handles: Search & Discovery Filter Display, 0-Count Hiding, Form Validations
 * ==============================================================================
 */

document.addEventListener("DOMContentLoaded", function () {

    applySakaFilterLogic();
    initSakaProductGallery();
    initSakaMobileSearch();

    // Watch for S&D AJAX Filter & Dynamic Content Updates
    const targetNode = document.querySelector('body');
    const config = { childList: true, subtree: true };
    let timer;

    const observer = new MutationObserver(() => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            applySakaFilterLogic();
            initSakaProductGallery();
            hideZeroReviewsBadge();
        }, 150);
    });
    if (targetNode) observer.observe(targetNode, config);

    // Zero-reviews hider on initial page load
    hideZeroReviewsBadge();

    // Keyboard arrow keys navigation for product detail gallery slideshow
    if (typeof jQuery !== 'undefined') {
        jQuery(document).on('keydown', function(e) {
            if (jQuery(e.target).is('input, textarea, select, [contenteditable]')) return;
            const activeGallery = jQuery('.productView [data-image-gallery-main].slick-initialized');
            if (!activeGallery.length) return;
            if (e.key === 'ArrowRight') {
                activeGallery.slick('slickNext');
            } else if (e.key === 'ArrowLeft') {
                activeGallery.slick('slickPrev');
            }
        });

        // Global thumbnail click handler for product page gallery switching
        jQuery(document).on('click', '.productView-thumbnail, .productView-thumbnail-link', function(e) {
            e.preventDefault();
            const target = jQuery(this);
            const thumbnail = target.hasClass('productView-thumbnail') ? target : target.closest('.productView-thumbnail');
            if (!thumbnail.length) return;
            
            const productView = thumbnail.closest('.productView');
            const mainGallery = productView.find('[data-image-gallery-main]');
            const thumbnails = productView.find('.productView-thumbnail');
            const index = thumbnails.index(thumbnail);
            
            if (mainGallery.hasClass('slick-initialized')) {
                mainGallery.slick('slickGoTo', index);
            } else {
                const mainImages = productView.find('.productView-image');
                if (mainImages.eq(index).length) {
                    mainImages.eq(index)[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                }
            }
            
            thumbnails.removeClass('is-active');
            thumbnail.addClass('is-active');
        });
    }

    validateSakaForms();

    // SAKA PRO: Initialize Custom Components
    initSakaCustomInformation();
    initSakaRelatedProducts();
    initSakaWishlist();
    initSakaCollectionSidebarMobile();
    initSakaHomeProductSliders();

    // Re-initialize if user selects a different variant (e.g., changes Size)
    document.addEventListener('change', (e) => {
        if (e.target.name === 'id' || e.target.closest('.variant-picker, .product-form__variants')) {
            // Note: quantity-manager component handles its own re-init if needed
        }
    });

    // Re-sync if the cart is updated anywhere else on the site
    window.addEventListener('cart:updated', () => {
        // Global cart update hook
    });
});

function applySakaFilterLogic() {
    const path = window.location.pathname.toLowerCase();

    // --- 1. SAFELY HIDE "0" COUNT FILTERS ---
    let emptyInputs = document.querySelectorAll('input[name^="filter."][disabled]');
    emptyInputs.forEach(input => {
        let listItem = input.closest('li, .facets__item, .filter-item');
        if (listItem) listItem.style.display = 'none';
    });

    // Fallback: Check text for "(0)"
    let filterLabels = document.querySelectorAll('.facets__item label, .filter-item label, .facet-checkbox, .sidebarBlock-content li');
    filterLabels.forEach(label => {
        if (label.innerText.trim().match(/\(0\)$/)) {
            let listItem = label.closest('li, .facets__item, .filter-item');
            if (listItem) listItem.style.display = 'none';
        }
    });

    // --- 2. EXCEL MAPPING: CUSTOM DISPLAY ---
    // Keywords to match in headings (case-insensitive)
    const filterMap = {
        'men': ['gender', 'style', 'fragrance', 'longevity', 'price', 'size', 'oud', 'leather', 'suede'],
        'women': ['gender', 'style', 'fragrance', 'longevity', 'price', 'size', 'oud', 'leather', 'suede'],
        'unisex': ['gender', 'style', 'fragrance', 'longevity', 'price', 'oud', 'leather', 'suede'],
        'new-arrivals': ['gender', 'style', 'price', 'fragrance'],
        'best-sellers': ['gender', 'style', 'price'],
        'gift-sets': ['gift type', 'price', 'occasion', 'gender'],
        'seasons': ['season', 'fragrance', 'style', 'price'],
        'luxury': ['gender', 'collection', 'longevity', 'fragrance', 'price']
    };

    let allowedFilters = null;
    for (const [handle, allowedWords] of Object.entries(filterMap)) {
        if (path.includes('/collections/' + handle)) {
            allowedFilters = allowedWords;
            break;
        }
    }

    if (allowedFilters) {
        // Find all blocks that look like filters
        let blocks = document.querySelectorAll('.sidebarBlock, .facets__disclosure, .filter-group');
        blocks.forEach(group => {
            let titleEl = group.querySelector('.sidebarBlock-heading, .facets__summary, .facets__heading, summary');
            if (titleEl) {
                let titleText = titleEl.innerText.toLowerCase().trim();
                
                // Always show "Category" or "Perfume Collections" blocks
                if (titleText.includes('category') || titleText.includes('collections') || titleText.includes('refined')) {
                    group.style.display = 'block';
                    return;
                }

                // Match against allowed words
                let isAllowed = allowedFilters.some(word => titleText.includes(word.toLowerCase()));
                if (!isAllowed) {
                    group.style.display = 'none';
                } else {
                    group.style.display = 'block';
                }
            }
        });
    }
}

function validateSakaForms() {
    // FIX: Contact form validation missing
    // Distinguish contact forms from newsletter forms to avoid validation conflicts
    const contactForms = document.querySelectorAll('form[action*="/contact"]:not(.newsletter-form):not([action*="/subscribe"])');
    contactForms.forEach(form => {
        form.addEventListener('submit', function (e) {
            let valid = true;
            let errorMsg = [];

            let email = form.querySelector('input[type="email"], input[name="contact[email]"]');
            let message = form.querySelector('textarea, textarea[name="contact[body]"]');

            if (email && !email.value.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                valid = false;
                errorMsg.push('- Please enter a valid email address.');
            }
            // Only validate message if it exists in the form (Newsletter forms usually don't have it)
            if (message && message.value.trim() === '') {
                valid = false;
                errorMsg.push('- Message field cannot be empty.');
            }

            if (!valid) {
                e.preventDefault();
                alert("Please fix the following errors:\n" + errorMsg.join("\n"));
            }
        });
    });

    // FIX: Newsletter signup email validation
    const newsletterForms = document.querySelectorAll('form.newsletter-form, form[action*="/subscribe"]');
    newsletterForms.forEach(form => {
        form.addEventListener('submit', function (e) {
            let email = form.querySelector('input[type="email"]');
            if (email && !email.value.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                e.preventDefault();
                alert('Please enter a valid email address to subscribe.');
                email.focus();
            }
        });
    });
}


/* * ==============================================================================
 * SAKA PRO: SIDEBAR CART UI / LOGIC BUG FIXES
 * ==============================================================================
 */

const openSidebar = () => {
    document.body.classList.add('cart-sidebar-show');
    // Ensure we trigger a refresh when opening manually too
    if (typeof Shopify !== 'undefined' && Shopify.getCart) {
        Shopify.getCart((cart) => {
            if (window.sharedFunctions?.updateSidebarCart) {
                window.sharedFunctions.updateSidebarCart(cart);
            }
        });
    }
};

/// Global shared functions
window.sharedFunctions = window.sharedFunctions || {};

window.sharedFunctions.refreshMainCart = function() {
    const isCartPage = window.location.pathname.includes('/cart');
    if (!isCartPage) return;
    const cartPageContainer = document.querySelector('#main-cart-items');
    if (!cartPageContainer) return;
    const sectionId = cartPageContainer.dataset.id || 'main';
    cartPageContainer.style.opacity = '0.5';

    fetch(`${window.location.pathname}?sections=${sectionId}`)
        .then(res => res.json())
        .then(json => {
            const html = json[sectionId] || json['main-cart'] || json['main'];
            if (html) {
                const parsed = new DOMParser().parseFromString(html, 'text/html');
                const newContent = parsed.querySelector('#main-cart-items');
                if (newContent) {
                    cartPageContainer.innerHTML = newContent.innerHTML;
                    document.dispatchEvent(new CustomEvent('cart-update'));
                }
            }
            cartPageContainer.style.opacity = '1';
        })
        .catch(err => {
            console.error('SAC PRO: Error refreshing main cart:', err);
            cartPageContainer.style.opacity = '1';
        });
};

window.sharedFunctions.updateSidebarCart = function(cart) {
    const wrapper = document.querySelector('.previewCart-wrapper');
    if (!wrapper) return;

    wrapper.style.opacity = '0.5';

    let fetchUrl = window.routes.root + '/cart?view=ajax_side_cart';
    if (fetchUrl.includes('//')) fetchUrl = fetchUrl.replace('//', '/'); // Basic cleanup

    fetch(fetchUrl)
        .then(response => response.text())
        .then(html => {
            wrapper.innerHTML = html;
            wrapper.style.opacity = '1';

            // Re-trigger currency conversion if applicable
            if (window.show_multiple_currencies && typeof Currency !== 'undefined') {
                Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
            }

            // Sync Header Cart Count
            const cartCounts = document.querySelectorAll('.cart-count-bubble, #cart-icon-bubble .text, .header-cart-count, .cartCount, [data-cart-count]');
            cartCounts.forEach(el => {
                if (el) el.textContent = cart.item_count;
            });
            
            // Sync singular/plural item text if needed
            const cartText = document.querySelector('[data-cart-text]');
            if (cartText) {
                cartText.textContent = cart.item_count === 1 ? 'item' : 'items';
            }

            document.dispatchEvent(new CustomEvent('sidebar-cart:refined'));
        })
        .catch(error => {
            console.error('Error updating sidebar cart:', error);
            wrapper.style.opacity = '1';
        });
};

// Also attach to window.halo for compatibility
window.halo = window.halo || {};
window.halo.updateSidebarCart = window.sharedFunctions.updateSidebarCart;

// Global AJAX Cart Interceptor (Safety Net for Redirects)
document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    // Skip if form is handled by product-form component natively
    if (form && !form.closest('product-form')) {
        // Block the default redirect immediately
        e.preventDefault();
        e.stopImmediatePropagation();

        const submitButton = form.querySelector('[type="submit"], .product-form__submit');
        if (submitButton) {
            submitButton.classList.add('is-loading'); // Theme loading class
            submitButton.setAttribute('disabled', true);
        }

        const formData = new FormData(form);

        fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => response.json())
        .then(item => {
            if (item.id || item.variant_id) {
                const variantId = item.variant_id || item.id;
                const quantity = item.quantity || 1;

                // Success - Get full cart data to update UI
                Shopify.getCart((cart) => {
                    // Update Sidebar
                    if (window.sharedFunctions.updateSidebarCart) {
                        window.sharedFunctions.updateSidebarCart(cart);
                    }
                    
                    if (window.location.pathname.includes('/cart')) {
                        if (window.sharedFunctions.refreshMainCart) {
                            window.sharedFunctions.refreshMainCart();
                        }
                    } else {
                        // Open Sidebar
                        openSidebar();
                    }
                    
                    // Dispatch global events
                    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
                    document.dispatchEvent(new CustomEvent('cart:update-variant', {
                        detail: { variant_id: variantId, variantId: variantId, quantity: quantity }
                    }));
                });
            } else {
                console.warn('Cart add issue:', item);
                if (item.description) alert(item.description);
            }
        })
        .catch(error => {
            console.error('AJAX Add to Cart Error:', error);
        })
        .finally(() => {
            if (submitButton) {
                submitButton.classList.remove('is-loading');
                submitButton.removeAttribute('disabled');
            }
        });
    }
}, true); // Use capture phase to intercept early

function initSakaScrollToTop() {
    const backToTopBtn = document.getElementById('back-to-top');
    if (!backToTopBtn) return;

    window.addEventListener('scroll', () => {
        if (window.scrollY > 300) {
            backToTopBtn.classList.add('show');
        } else {
            backToTopBtn.classList.remove('show');
        }
    });

    backToTopBtn.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
}

// Global modal/sidebar handlers
const closeSidebar = () => {
    document.body.classList.remove('cart-sidebar-show');
};

document.addEventListener('DOMContentLoaded', () => {
    initSakaCollectionSidebarMobile();
    initSakaScrollToTop();

    // Listen for clicks on the close button and background overlay
    document.addEventListener('click', (e) => {
        if (e.target.closest('[data-close-cart-sidebar]') || e.target.classList.contains('background-overlay')) {
            closeSidebar();
        }

        // --- SAC PRO: Open Sidebar on Header Cart Click ---
        const cartLink = e.target.closest('a[href="/cart"], a[href$="/cart"]');
        if (cartLink && !e.target.closest('.previewCartGroup')) { // Don't intercept buttons inside the sidebar itself
            if (!window.location.pathname.includes('/cart')) {
                e.preventDefault();
                e.stopPropagation();
                openSidebar();
                
                // Refresh cart content
                if (typeof Shopify !== 'undefined' && Shopify.getCart) {
                    Shopify.getCart((updatedCart) => {
                         if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function') {
                             window.sharedFunctions.updateSidebarCart(updatedCart);
                         } else if (window.halo && typeof window.halo.updateSidebarCart === 'function') {
                             window.halo.updateSidebarCart(updatedCart);
                         }
                    });
                }
            }
        }

        // --- SAC PRO: Tooltip Click Toggle (More Global) ---
        const infoIcon = e.target.closest('.icon-info') || e.target.closest('.product-customInformation__icon') || e.target.closest('.icon-important-note') || e.target.closest('.progress-truck-wrapper') || (e.target.innerText === 'i' && e.target.classList.contains('text'));
        if (infoIcon) {
            const wrapper = infoIcon.closest('[data-custom-information]') || infoIcon.parentElement;
            const popup = wrapper?.querySelector('.product-customInformation__popup, .alertBox-message, .tooltip'); // Try common selectors
            if (popup) {
                e.preventDefault();
                e.stopPropagation();
                popup.classList.toggle('is-active');
                popup.classList.remove('hidden'); // Ensure hidden class doesn't block it
            }
        } else {
            // Close all popups if clicking elsewhere
            document.querySelectorAll('.product-customInformation__popup').forEach(p => p.classList.remove('is-active'));
        }
    });

    // --- SAC PRO: Tooltip Hover Support (More Global) ---
    document.addEventListener('mouseover', (e) => {
        const infoIcon = e.target.closest('.icon-info') || e.target.closest('.product-customInformation__icon') || e.target.closest('.icon-important-note') || e.target.closest('.progress-truck-wrapper');
        if (infoIcon) {
            const wrapper = infoIcon.closest('[data-custom-information]') || infoIcon.parentElement;
            const popup = wrapper?.querySelector('.product-customInformation__popup');
            if (popup) {
                popup.classList.add('is-active');
                popup.classList.remove('hidden');
            }
        }
    });

    document.addEventListener('mouseout', (e) => {
        const infoIcon = e.target.closest('.icon-info') || e.target.closest('.product-customInformation__icon') || e.target.closest('.icon-important-note') || e.target.closest('.progress-truck-wrapper');
        if (infoIcon) {
            const wrapper = infoIcon.closest('[data-custom-information]') || infoIcon.parentElement;
            const popup = wrapper?.querySelector('.product-customInformation__popup');
            if (popup) popup.classList.remove('is-active');
        }
    });

    // --- SAKA PRO: Unified Cart AJAX Manager (Sidebar & Main Cart) ---
    function updateCartQuantities(line, quantity) {
        const isCartPage = window.location.pathname.includes('/cart');
        const sidebarWrapper = document.querySelector('.previewCart-wrapper');
        const cartPageContainer = document.querySelector('#main-cart-items');
        
        if (sidebarWrapper) sidebarWrapper.style.opacity = '0.5';
        if (cartPageContainer) cartPageContainer.style.opacity = '0.5';

        fetch(window.routes.cart_change_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: line, quantity: quantity })
        })
        .then(response => response.json())
        .then(cart => {
            if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function') {
                window.sharedFunctions.updateSidebarCart(cart);
            }
            if (isCartPage && window.sharedFunctions && typeof window.sharedFunctions.refreshMainCart === 'function') {
                window.sharedFunctions.refreshMainCart();
            } else if (cartPageContainer) {
                cartPageContainer.style.opacity = '1';
            }
        })
        .catch(error => {
            console.error('SAC PRO: Error updating cart:', error);
            if (sidebarWrapper) sidebarWrapper.style.opacity = '1';
            if (cartPageContainer) cartPageContainer.style.opacity = '1';
        });
    }

    document.addEventListener('change', (e) => {
        const qttInput = e.target.closest('[data-cart-quantity]');
        if (qttInput) {
            updateCartQuantities(qttInput.dataset.line, qttInput.value);
        }
    });

    document.addEventListener('click', (e) => {
        const removeBtn = e.target.closest('[data-cart-remove]');
        if (removeBtn) {
            e.preventDefault();
            updateCartQuantities(removeBtn.dataset.line, 0);
        }
    });

    // Support Escape key for closing
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeSidebar();
            document.querySelectorAll('.product-customInformation__popup').forEach(p => p.classList.remove('is-active'));
        }
    });
});

function initSakaCustomInformation() {
    const infos = document.querySelectorAll('[data-custom-information]');
    infos.forEach(info => {
        if (info.classList.contains('disabled')) return;
        
        info.addEventListener('click', (e) => {
            // If the click was on the info icon, handle it
            const isClickOnIcon = e.target.closest('.icon-info') || e.target.closest('.product-customInformation__icon');
            const popup = info.querySelector('.product-customInformation__popup');
            
            if (isClickOnIcon && popup) {
                e.preventDefault();
                e.stopPropagation();
                popup.classList.toggle('hidden');
            }
        });
    });
}

/* * ==============================================================================
 * SAKA PRO: RELATED PRODUCTS FETCH ENGINE
 * ==============================================================================
 */

function initSakaRelatedProducts() {
    const recBlocks = document.querySelectorAll('[data-recommendations-block]');
    recBlocks.forEach(block => {
        const url = block.dataset.url;
        if (!url) return;

        // Skip if recommendations are already loaded (not skeleton)
        const hasLoading = block.querySelector('.product-recommendations-loading');
        const hasSkeletonCards = block.querySelector('.product-card-loading');
        if (!hasLoading && !hasSkeletonCards) return;

        fetch(url)
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text();
            })
            .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('[data-recommendations-block]');
                
                if (recommendations && recommendations.innerHTML.trim().length > 0) {
                    block.innerHTML = recommendations.innerHTML;

                    // Initialize sliders if needed
                    const productCarousel = block.querySelector('.products-carousel');
                    if (productCarousel && typeof $ !== 'undefined' && $.fn.slick) {
                        const itemToShow = parseInt(productCarousel.dataset.itemToShow) || 4;
                        const itemDots = productCarousel.dataset.itemDots === 'true';
                        const itemArrows = productCarousel.dataset.itemArrows === 'true';

                        if (!productCarousel.classList.contains('slick-slider')) {
                            $(productCarousel).slick({
                                dots: itemDots,
                                arrows: itemArrows,
                                slidesToShow: itemToShow,
                                slidesToScroll: 1,
                                infinite: true,
                                rtl: window.rtl_slick,
                                nextArrow: window.arrows?.icon_next,
                                prevArrow: window.arrows?.icon_prev,
                                responsive: [
                                    { breakpoint: 1025, settings: { slidesToShow: Math.min(itemToShow, 3) } },
                                    { breakpoint: 768, settings: { slidesToShow: 2 } },
                                    { breakpoint: 480, settings: { slidesToShow: 1 } }
                                ]
                            });
                        }
                    }

                    // Re-trigger currency conversion if applicable
                    if (window.show_multiple_currencies && typeof Currency !== 'undefined') {
                        Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                    }
                }
            })
            .catch(e => console.error('Failed to load recommendations:', e));
    });
}

function initSakaHomeProductSliders() {
    const productBlocks = document.querySelectorAll('[data-product-block]');
    productBlocks.forEach(block => {
        const productCarousel = block.querySelector('.products-carousel');
        if (productCarousel && typeof $ !== 'undefined' && $.fn.slick) {
            const itemToShow = parseInt(productCarousel.dataset.itemToShow) || 4;
            const itemDots = productCarousel.dataset.itemDots === 'true';
            const itemArrows = productCarousel.dataset.itemArrows === 'true';
            const itemInfinite = productCarousel.dataset.infinite === 'true';
            const itemAutoplay = productCarousel.dataset.autoplay === 'true';
            const autoplaySpeed = parseInt(productCarousel.dataset.autoplaySpeed) || 3000;

            if (!productCarousel.classList.contains('slick-slider')) {
                $(productCarousel).slick({
                    dots: itemDots,
                    arrows: itemArrows,
                    slidesToShow: itemToShow,
                    slidesToScroll: 1,
                    infinite: itemInfinite,
                    autoplay: itemAutoplay,
                    autoplaySpeed: autoplaySpeed,
                    rtl: window.rtl_slick,
                    nextArrow: window.arrows?.icon_next || '<button type="button" class="slick-next">Next</button>',
                    prevArrow: window.arrows?.icon_prev || '<button type="button" class="slick-prev">Previous</button>',
                    responsive: [
                        { breakpoint: 1025, settings: { slidesToShow: Math.min(itemToShow, 3) } },
                        { breakpoint: 768, settings: { slidesToShow: 2 } },
                        { breakpoint: 480, settings: { slidesToShow: 1 } }
                    ]
                });
            }
        }
    });
}


/* * ==============================================================================
 * SAKA PRO: GLOBAL WISHLIST MANAGER
 * Handle clicks on all [data-wishlist] buttons (Product Cards, Product Page)
 * Syncs with localStorage ['wishlistItem']
 * ==============================================================================
 */

function initSakaWishlist() {
    const syncWishlistUI = () => {
        const wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];
        
        // Update counts
        const countEls = document.querySelectorAll('[data-wishlist-count]');
        countEls.forEach(el => {
            if (el.textContent !== String(wishlistList.length)) {
                el.textContent = wishlistList.length;
            }
        });

        // Update all wishlist buttons
        const allWishlistBtns = document.querySelectorAll('[data-wishlist-handle]');
        allWishlistBtns.forEach(btn => {
            const handle = btn.dataset.wishlistHandle;
            
            if (wishlistList.includes(handle)) {
                if (!btn.classList.contains('wishlist-added')) {
                    btn.classList.add('wishlist-added');
                    updateBtnText(btn, window.wishlist?.added);
                }
            } else {
                if (btn.classList.contains('wishlist-added')) {
                    btn.classList.remove('wishlist-added');
                    updateBtnText(btn, window.wishlist?.add);
                }
            }
        });
    };

    const updateBtnText = (btn, text) => {
        if (!text) return;
        const textEl = btn.querySelector('.text');
        if (textEl) {
            if (textEl.innerText !== text) textEl.innerText = text;
        } else if (btn.tagName === 'A' || btn.tagName === 'BUTTON') {
            // Some buttons might not have .text span
            if (btn.innerText !== text && btn.childNodes.length === 1) btn.innerText = text;
        }
    };

    syncWishlistUI();

    // Global Click Listener
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-wishlist]');
        if (btn) {
            e.preventDefault();
            e.stopPropagation();

            const handle = btn.dataset.wishlistHandle;
            if (!handle) return;

            let wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];
            const index = wishlistList.indexOf(handle);
            const isAdding = index === -1;

            if (isAdding) {
                wishlistList.push(handle);
            } else {
                wishlistList.splice(index, 1);
            }

            localStorage.setItem('wishlistItem', JSON.stringify(wishlistList));
            
            // Re-sync all UI elements
            syncWishlistUI();

            // Special handling for Wishlist Page: if we "remove" an item, hide its card
            if (window.location.pathname.includes('/pages/wish-list') || window.location.pathname.includes('/pages/wishlist')) {
                if (!isAdding) {
                    const productCard = btn.closest('.product');
                    if (productCard) {
                        productCard.style.opacity = '0.3';
                        productCard.style.pointerEvents = 'none';
                        setTimeout(() => productCard.remove(), 300);
                    }
                }
            }
            
            // Dispatch event for any other listeners
            document.dispatchEvent(new CustomEvent('wishlist:sync', { detail: { handle, wishlistList, isAdding } }));
        }
    });

    // Watch for AJAX changes with a debounce to prevent infinite loops
    if (typeof MutationObserver !== 'undefined') {
        let wishTimer;
        const observer = new MutationObserver((mutations) => {
            // Avoid triggering on our own changes if possible
            const isSelfTriggered = mutations.every(m => 
                m.target.closest?.('[data-wishlist-count]') || 
                m.target.closest?.('[data-wishlist-handle]')
            );
            if (isSelfTriggered) return;

            clearTimeout(wishTimer);
            wishTimer = setTimeout(syncWishlistUI, 300);
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }
}

/* * ==============================================================================
 * SAKA PRO: COLLECTION SIDEBAR MOBILE FIX
 * Handle missing JS for mobile collection filter toggling
 * ==============================================================================
 */

function initSakaCollectionSidebarMobile() {
    document.addEventListener('click', function(e) {
        // Handle Open Sidebar
        const openBtn = e.target.closest('[data-sidebar]');
        if (openBtn) {
            e.preventDefault();
            e.stopPropagation();
            document.body.classList.add('open-mobile-sidebar');
            return;
        }

        // Handle Close Sidebar
        const closeBtn = e.target.closest('[data-close-sidebar]');
        if (closeBtn) {
            e.preventDefault();
            e.stopPropagation();
            document.body.classList.remove('open-mobile-sidebar');
            return;
        }

        // Handle Overlay Click
        const overlay = e.target.closest('.background-overlay');
        if (overlay && document.body.classList.contains('open-mobile-sidebar')) {
            document.body.classList.remove('open-mobile-sidebar');
            return;
        }
    });
}

/* * ==============================================================================
 * SAKA PRO: DYNAMIC PRODUCT DETAIL GALLERY LOOPER
 * Initializes Slick slider on main product page gallery and binds autoplay
 * ==============================================================================
 */
function initSakaProductGallery() {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') return;

    jQuery('.productView').each(function() {
        const productView = jQuery(this);
        const mainGallery = productView.find('[data-image-gallery-main]');
        if (mainGallery.length && !mainGallery.hasClass('slick-initialized')) {
            const arrowsDesk = mainGallery.attr('data-arrows-desk') === 'true';
            const arrowsMobi = mainGallery.attr('data-arrows-mobi') === 'true';

            mainGallery.slick({
                infinite: true,
                speed: 500,
                autoplay: true,
                autoplaySpeed: 4000, // Automoves main slideshow slowly every 4 seconds
                arrows: arrowsDesk,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                rtl: window.rtl_slick,
                prevArrow: window.arrows?.icon_prev || '<button type="button" class="slick-prev">Previous</button>',
                nextArrow: window.arrows?.icon_next || '<button type="button" class="slick-next">Next</button>',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: arrowsMobi,
                            dots: true
                        }
                    }
                ]
            });
            
            // Add mouse hover pause controls
            mainGallery.on('mouseenter', function() {
                mainGallery.slick('slickPause');
            }).on('mouseleave', function() {
                mainGallery.slick('slickPlay');
            });
            
            // Highlight the matching thumbnail slide on change
            mainGallery.on('afterChange', function(event, slick, currentSlide) {
                const thumbnails = productView.find('.productView-thumbnail');
                thumbnails.removeClass('is-active');
                thumbnails.eq(currentSlide).addClass('is-active');
            });
        }
    });
}

/* * ==============================================================================
 * SAKA PRO: BULLETPROOF ZERO-REVIEWS BADGE HIDER
 * Hides Judge.me elements containing "No reviews" or with data-number-of-reviews="0"
 * ==============================================================================
 */
function hideZeroReviewsBadge() {
    if (typeof jQuery === 'undefined') return;

    jQuery('.jdgm-prev-badge, .jdgm-preview-badge').each(function() {
        const badge = jQuery(this);
        const text = badge.text().trim().toLowerCase();
        const numReviews = badge.attr('data-number-of-reviews');
        if (numReviews === '0' || text.includes('no reviews') || badge.hasClass('jdgm--no-reviews')) {
            badge.attr('style', 'display: none !important;');
        }
    });
}

/* * ==============================================================================
 * SAKA MOBILE SEARCH TOGGLE HANDLER
 * ==============================================================================
 */
function initSakaMobileSearch() {
    document.addEventListener('click', function(e) {
        const toggle = e.target.closest('[data-search-mobile]');
        if (toggle) {
            e.preventDefault();
            e.stopPropagation();
            document.body.classList.add('open_search_mobile');
            const searchInput = document.querySelector('#search-form-mobile input[type="search"], #Search-In-Modal-Sidebar');
            if (searchInput) {
                setTimeout(() => searchInput.focus(), 200);
            }
            return;
        }

        const closeBtn = e.target.closest('[data-search-close-sidebar], .halo-sidebar_search .halo-sidebar-close');
        if (closeBtn) {
            e.preventDefault();
            e.stopPropagation();
            document.body.classList.remove('open_search_mobile');
            return;
        }

        if (document.body.classList.contains('open_search_mobile')) {
            const sidebar = e.target.closest('#search-form-mobile, .halo-sidebar_search');
            const openToggle = e.target.closest('[data-search-mobile]');
            if (!sidebar && !openToggle && e.target.classList.contains('background-overlay')) {
                document.body.classList.remove('open_search_mobile');
            }
        }
    });

    document.addEventListener('keyup', function(e) {
        if (e.key === 'Escape' && document.body.classList.contains('open_search_mobile')) {
            document.body.classList.remove('open_search_mobile');
        }
    });
}
